export type Size =
    'Small' |
    'Medium' |
    'Large';

export class Sizes {
    public static readonly SMALL: Size = 'Small';
    public static readonly MEDIUM: Size = 'Medium';
    public static readonly LARGE: Size = 'Large';
}